module.exports = __webpack_public_path__ + "static/img/button.43a072f1.svg";